import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "team-manage" }
const _hoisted_2 = {
  class: "flex-row-box video-name",
  style: {"justify-content":"flex-start"}
}
const _hoisted_3 = {
  class: "flex-row-box",
  style: {"justify-content":"flex-start"}
}
const _hoisted_4 = { style: {"color":"#909399"} }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "flex-row-box" }
const _hoisted_7 = {
  class: "color-info font12",
  style: {"margin-left":"10px"}
}
const _hoisted_8 = {
  key: 1,
  class: "color-info font12 mt30 flex flex-center"
}
const _hoisted_9 = { class: "tree-item" }
const _hoisted_10 = { class: "flex-column-box border-left-box" }
const _hoisted_11 = { class: "label" }
const _hoisted_12 = { class: "text" }

import { ref, reactive, onMounted, watch } from 'vue';
import GroupDialog from './components/GroupDialog.vue';
import UserGroupDialog from './components/UserGroupDialog.vue';
import InviteMember from './components/InviteMember.vue';
import {
  getAppTeamAllGroupList,
  getAppTeamUserPage,
  updateAppTeamName,
  removeAppTeamUserApi,
  deleteGroupApi,
} from '@/request/team';
import { useTable, delTable } from '@/hooks/useTable';
import CustomTable from '@/components/Custom/CustomTable/index.vue';
import CustomPagination from '@/components/Custom/CustomPagination/index.vue';
import { useRoute } from 'vue-router';
import { useMainStore } from '@/pinia';
import router from '@/router';
import { ElMessage } from 'element-plus';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useMainStore();
const route = useRoute();

const currentTeamId = route?.params.id;
const currentGroup = ref({});
const { teamInfo } = store;

const inviteDialogRef = ref();
const userGroupDialogRef = ref();

const editVideoName = (ev) => {
  const teamName = ev.target.innerText;
  updateAppTeamName({ teamId: teamInfo?.id, teamName }).then((res) => {
    //todo
    location.reload();
  });
};

// 表格列信息
const columns = [
  {
    prop: 'nickname',
    label: '姓名',
    isCustom: true,
  },
  {
    prop: 'groupName',
    label: '所属用户组',
  },
  {
    prop: 'teamOperateTime',
    label: '最后操作时间',
  },
  {
    prop: 'isOwner',
    label: '角色',
    isCustom: true,
  },
  {
    prop: 'inviteTeamUserNickname',
    label: '邀请人',
  },
  {
    prop: 'operation',
    label: '操作',
    isCustom: true,
    fixed: 'right',
  },
];

function openInviteDialog(data = {}) {
  inviteDialogRef.value?.openDialog(data);
}

function openUserGroupDialog(data = {}) {
  userGroupDialogRef.value.openDialog(data);
}

const tableConfig = reactive({
  request: getAppTeamUserPage,
  // request: getAppTeamUserPageByGroupId,
  afterRequest: (res) => res?.data?.data || {},
  initParam: {
    teamId: currentTeamId,
    groupId: currentGroup.value?.id,
  },
  isShowPage: true,
  immediate: false,
});
// 获取表格数据
const { tableData, search, pagination, getTableData, changePage, changeSize } = useTable(tableConfig);

// 移除团队
function removeAppTeamUser(row: any) {
  delTable({
    // id: row.id,
    params: { userId: row.userId, teamId: row.teamId },
    request: removeAppTeamUserApi,
    callback: () => {
      getTableData();
    },
  });
}

const onNavChange = (name) => {
  router.push(name);
};

/**
 * 用户组
 * */
const groupDialogRef = ref();
// 用户组数据
const allItem = [{ name: '全部成员', id: 'all' }];
const groupList = reactive({
  data: allItem,
});

// 获取用户组
function fetchAppTeamAllGroupList() {
  getAppTeamAllGroupList(currentTeamId).then((res) => {
    const list = allItem.concat(res?.data?.data || []);
    groupList.data = list;
    pickGroup(list[0]?.id, list[0] || {});
  });
}

// 打开用户组类型弹框
function openGroupDialog(data = {}) {
  groupDialogRef.value.openDialog(data, { groupId: data.id, groupName: data.name });
}

// 删除用户组
function delGroup(row: any) {
  delTable({
    id: row.id,
    request: deleteGroupApi,
    callback: () => {
      fetchAppTeamAllGroupList();
    },
  });
}

// 选择用户组
function pickGroup(id: string, item: any) {
  currentGroup.value = item;
  tableConfig.initParam.groupId = id;
  getTableData();
}

onMounted(() => {
  fetchAppTeamAllGroupList();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_svgIcon = _resolveComponent("svgIcon")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_MoreFilled = _resolveComponent("MoreFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, {
      class: "border-none dark-bg mg-b-24",
      shadow: "never"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          class: "font-s-20",
          link: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (onNavChange('/work-plateform')))
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode("返回工作台")
          ])),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      class: "border-none dark-bg",
      shadow: "never"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 10 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, {
              span: 6,
              class: "font-s-20 mg-b-24 font-w-500"
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_2, [
                  _cache[5] || (_cache[5] = _createElementVNode("span", { style: {"color":"#909399"} }, "名称：", -1)),
                  _createElementVNode("span", {
                    class: "mg-r-10",
                    contenteditable: "true",
                    onBlur: _cache[1] || (_cache[1] = ($event: any) => (editVideoName($event)))
                  }, _toDisplayString(_unref(teamInfo)?.name), 33),
                  _createVNode(_component_svgIcon, {
                    iconClass: "edit",
                    class: "editIcon"
                  })
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, "团队ID：" + _toDisplayString(_unref(teamInfo)?.id), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 18,
              style: {"text-align":"right"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (openInviteDialog({ teamId: _unref(teamInfo)?.id })))
                }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode(" 邀请成员 ")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 6,
              class: "colTitle"
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode("成员管理")
              ])),
              _: 1
            }),
            _createVNode(_component_el_col, {
              span: 18,
              class: "colTitle"
            }, {
              default: _withCtx(() => [
                _createTextVNode("当前视图：" + _toDisplayString(currentGroup.value.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_card, {
                  shadow: "never",
                  class: "border-none left container"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      class: "addGroupBtn",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (openGroupDialog({ teamId: _unref(teamInfo)?.id })))
                    }, {
                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                        _createTextVNode(" 新建用户组 ")
                      ])),
                      _: 1
                    }),
                    (groupList.data.length > 0)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(groupList.data, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass([currentGroup.value?.id === item.id ? 'selected' : '', "dict-type-item flex-row-box"]),
                            onClick: ($event: any) => (pickGroup(item.id, item))
                          }, [
                            _createElementVNode("span", null, _toDisplayString(item.name), 1),
                            _createElementVNode("span", _hoisted_6, [
                              (item.id !== 'all')
                                ? (_openBlock(), _createBlock(_component_el_dropdown, {
                                    key: 0,
                                    size: "small",
                                    type: "primary"
                                  }, {
                                    dropdown: _withCtx(() => [
                                      _createVNode(_component_el_dropdown_menu, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_dropdown_item, {
                                            onClick: ($event: any) => (openGroupDialog(item))
                                          }, {
                                            default: _withCtx(() => _cache[9] || (_cache[9] = [
                                              _createTextVNode("修改用户组")
                                            ])),
                                            _: 2
                                          }, 1032, ["onClick"]),
                                          _createVNode(_component_el_dropdown_item, {
                                            style: {"color":"#c80000"},
                                            onClick: ($event: any) => (delGroup(item))
                                          }, {
                                            default: _withCtx(() => _cache[10] || (_cache[10] = [
                                              _createTextVNode("删除")
                                            ])),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_icon, { class: "more" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_MoreFilled)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", _hoisted_7, _toDisplayString(item.id === 'all' ? _unref(pagination).total : item.count), 1)
                            ])
                          ], 10, _hoisted_5))
                        }), 256))
                      : (_openBlock(), _createElementBlock("div", _hoisted_8, " 暂无数据 "))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 18 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_card, {
                  shadow: "never",
                  class: "border-none container"
                }, {
                  default: _withCtx(() => [
                    _createVNode(CustomTable, {
                      columns: columns,
                      data: _unref(tableData),
                      initParam: groupList.initParam
                    }, {
                      nickname: _withCtx(({ row }) => [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_el_image, {
                            class: "avatar",
                            src: row.head
                          }, null, 8, ["src"]),
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, _toDisplayString(row.nickname), 1),
                            _createElementVNode("div", _hoisted_12, _toDisplayString(row.phone), 1)
                          ])
                        ])
                      ]),
                      isOwner: _withCtx(({ row }) => [
                        _createElementVNode("span", null, _toDisplayString(row.isOwner ? '所有者' : '用户'), 1)
                      ]),
                      status: _withCtx(({ row }) => [
                        (row.status)
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 0,
                              type: "success",
                              "disable-transitions": ""
                            }, {
                              default: _withCtx(() => _cache[11] || (_cache[11] = [
                                _createTextVNode("启用")
                              ])),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_el_tag, {
                              key: 1,
                              type: "danger",
                              "disable-transitions": ""
                            }, {
                              default: _withCtx(() => _cache[12] || (_cache[12] = [
                                _createTextVNode("禁用")
                              ])),
                              _: 1
                            }))
                      ]),
                      operation: _withCtx(({ row }) => [
                        _createVNode(_component_el_button, {
                          link: "",
                          type: "primary",
                          onClick: ($event: any) => (openUserGroupDialog(row))
                        }, {
                          default: _withCtx(() => _cache[13] || (_cache[13] = [
                            _createTextVNode(" 修改所属用户组 ")
                          ])),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_el_button, {
                          link: "",
                          type: "primary",
                          style: {"color":"red"},
                          onClick: ($event: any) => (removeAppTeamUser(row))
                        }, {
                          default: _withCtx(() => _cache[14] || (_cache[14] = [
                            _createTextVNode(" 移除团队 ")
                          ])),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 1
                    }, 8, ["data", "initParam"]),
                    _createVNode(CustomPagination, {
                      total: _unref(pagination).total,
                      currentPage: _unref(pagination).pageIndex,
                      pageSize: _unref(pagination).pageSize,
                      onChangePage: _unref(changePage),
                      onChangeSize: _unref(changeSize)
                    }, null, 8, ["total", "currentPage", "pageSize", "onChangePage", "onChangeSize"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(UserGroupDialog, {
          ref_key: "userGroupDialogRef",
          ref: userGroupDialogRef,
          onRefresh: _unref(getTableData)
        }, null, 8, ["onRefresh"]),
        _createVNode(InviteMember, {
          ref_key: "inviteDialogRef",
          ref: inviteDialogRef,
          onRefresh: _unref(getTableData)
        }, null, 8, ["onRefresh"]),
        _createVNode(GroupDialog, {
          ref_key: "groupDialogRef",
          ref: groupDialogRef,
          onRefresh: fetchAppTeamAllGroupList
        }, null, 512)
      ]),
      _: 1
    })
  ]))
}
}

})